import { render, staticRenderFns } from "./PhoneButton.vue?vue&type=template&id=55b4374d&scoped=true"
import script from "./PhoneButton.vue?vue&type=script&lang=js"
export * from "./PhoneButton.vue?vue&type=script&lang=js"
import style0 from "./PhoneButton.vue?vue&type=style&index=0&id=55b4374d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4374d",
  null
  
)

export default component.exports